import type Account from "@travily/types/models/Account";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";

interface ConversationHeaderProps {
  account: Account;
}

export function ConversationHeader({ account }: ConversationHeaderProps) {
  return (
    <div className="flex items-center gap-3 border-neutral-100 border-b pb-4">
      <AccountAvatar account={account} shape="circle" size="40" />
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-semibold text-lg text-neutral-900">{account.display_name}</span>
        {account.handle && (
          // eslint-disable-next-line i18next/no-literal-string -- "@" prefix is not translatable
          <span className="truncate text-neutral-500 text-sm">@{account.handle}</span>
        )}
      </div>
    </div>
  );
}
